import axios from 'axios'
import { ProjectOption } from 'src/core/models'

export async function getProjectOptionsListtAPI(): Promise<ProjectOption[]> {
  const url = '/api/v1/projects_options/get_all/'
  const { data } = await axios.get<{data: ProjectOption[]}>(url)
  return data?.data
}

export async function validateProjectOption(id: number): Promise<boolean> {
  const url = `/api/v1/projects_options/${id}/validate`
  const { data } = await axios.get<{is_valid: boolean}>(url)
  return data?.is_valid
}
